import { checkUserAuth } from "actions";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIsAuthenticated } from "selectors";

// For PrivateRoute: validate the session once on first mount when auth is
// unconfirmed (default false before rehydration, or cy.session restore without
// cached IndexedDB). The ref survives Redux state resets so a DevTools
// state-clear falls through to a /login redirect instead of re-checking.
export const useCheckAuth = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const hasCheckedAuth = useRef(false);

  useEffect(() => {
    // null means a check is already in flight; only act when explicitly false
    if (isAuthenticated !== false || hasCheckedAuth.current) return;
    hasCheckedAuth.current = true;
    dispatch(checkUserAuth("/login"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

// For RedirectToSale (king links): always validate on mount without selecting
// the default role - the caller sets the role explicitly via setActiveRole.
export const useCheckAuthForKingLink = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkUserAuth("/login", false));
  }, [dispatch]);
};
